import { ApiFilterResponse } from '@interfaces/ackoDrive'
import { errorWithStack } from '@utils/logger'

export const filterService = {
  getFilters: async (collectionSlug?: string): Promise<ApiFilterResponse | null> => {
    try {
      const queryParams = new URLSearchParams()

      if (collectionSlug) {
        queryParams.append('slug', collectionSlug)
      }

      const queryString = queryParams.toString()
      const apiUrl = queryString ? `/api/catalog/filters/?${queryString}` : '/api/catalog/filters/'

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })

      if (!response.ok) {
        throw new Error(`Filter API HTTP error! Status: ${response.status}`)
      }

      const data = await response.json()

      return data
    } catch (error) {
      errorWithStack('Error fetching filter options from API:', error)
      return null
    }
  },
}
